<template>
  <div class="side-navi">
    <div class="logo" @click="onClickHome"><img src="../../static/img/logo.png" width="90" height="85"></div>
    <el-menu class="link-container" :unique-opened="true">
      <el-menu-item index="home" class="link" @click="changeLocation('model-list')">ホーム</el-menu-item>
      <el-submenu index="tools">
        <template slot="title" class="link"><span class="toggle">ツール</span></template>
        <el-menu-item index="data-convert" class="link" @click="changeLocation('data-convert')">データ変換</el-menu-item>
<!--        <el-menu-item index="data-collect" class="link" @click="changeLocation('data-collect')">データ収集</el-menu-item>-->
      </el-submenu>
      <el-menu-item index="account" class="link" @click="changeLocation('account')">アカウント</el-menu-item>
      <el-menu-item index="information" class="link information" :class="{ 'is-new-info': isNewInfo }"
                    @click="changeLocation('information')">お知らせ<i class="icon el-icon-warning"></i></el-menu-item>
      <el-submenu index="others">
        <template slot="title" class="link toggle"><span class="toggle">その他</span></template>
        <el-menu-item index="samples" class="link" @click="changeLocation('samples')">サンプルデータ</el-menu-item>
        <el-menu-item index="faq" class="link" @click="onClickFaq">FAQ</el-menu-item>
        <el-menu-item index="support" class="link" @click="changeLocation('support-list')" v-if="supportEnabled">
          お問い合わせ
        </el-menu-item>
        <el-menu-item index="support" class="link" @click="onClickTerms" v-if="supportEnabled">利用規約</el-menu-item>
        <el-menu-item index="credit" class="link" @click="changeLocation('credit')">クレジット</el-menu-item>
      </el-submenu>
      <el-menu-item index="logout" class="link" @click="onClickLogout" style="color: rgba(202,24,46,0.67);">ログアウト</el-menu-item>
    </el-menu>
    <div class="user">
      <div>{{customerName}}</div>
      <div>{{ userName }}　様</div>
    </div>
  </div>
</template>

<script>

import WebApiClient from '../api/web'

export default {
  name: 'SideNaviCmp',
  components: {},
  props: {
    isNewInfo: false
  },
  data () {
    return {
      customerName: '',
      userName: ''
    }
  },
  computed: {
    supportEnabled () {
      return this.$session.get('SUPPORT_ENABLED')
    }
  },
  created () {
    this.customerName = this.$session.get('CUSTOMER_NAME')
    this.userName = this.$session.get('USER_NAME')
  },
  beforeMount () {
    this.$on('update-notifications', this.onUpdateNotification)
  },
  beforeDestroy () {
    this.$off('update-notifications', this.onUpdateNotification)
  },
  methods: {
    changeLocation (name, params) {
      if (this.$route.name !== name) {
        this.$router.push({
          name: name,
          params: params
        })
      } else {
        window.location.reload()
      }
    },
    onClickHome () {
      this.changeLocation('model-list')
    },
    onClickFaq () {
      window.open('https://blog.skyfox.ai/entry/FAQ')
    },
    onClickTerms () {
      window.open('https://skyfox.ai/terms_of_service.pdf')
    },
    onClickLogout () {
      WebApiClient.logout(this, {}).then(response => {
        this.$session.destroy()
        this.$router.push('/login')
      })
    },
    onUpdateNotification (notifications) {
      this.isNewInfo = notifications.isNewInfo
    }
  }
}

</script>

<style scoped>
  .side-navi {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 180px;
    background: url(../../static/img/bg_sidebar.png) repeat-y left top rgba(255, 255, 255, 0.4);
  }

  .logo {
    display: flex;
    width: inherit;
    max-height: 150px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 1;
  }

  .link-container {
    border-top: 1px solid #dcebf6;
    border-bottom: 1px solid #dcebf6;
    margin: 0;
    padding: 12px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
  }

  .menubar,
  .el-menu,
  .link-container >>> .el-submenu > .el-menu,
  .link-container >>> .el-menu-item:focus,
  .link-container >>> .el-menu-item:hover,
  .link-container >>> .el-submenu .el-submenu__title:focus,
  .link-container >>> .el-submenu .el-submenu__title:hover,
  .link-container >>> .el-submenu .el-menu-item:focus,
  .link-container >>> .el-submenu .el-menu-item:hover {
    background-color: transparent;
    border-right: none;
  }

  .el-menu-item,
  .link-container >>> .el-submenu .el-submenu__title,
  .link-container >>> .el-submenu .el-menu-item {
    font-size: 0.9rem;
    height: 32px;
    line-height: 32px;
    min-width: inherit;
  }

  .el-menu-item,
  .link-container >>> .el-submenu .el-submenu__title {
    padding: 2px;
  }

  .user {
    flex-shrink: 0;
    margin: 12px 16px;
    font-size: 0.77rem;
    line-height: 1.6;
  }

  .information > .icon {
    display: none;
  }

  .el-menu-item.information.is-new-info,
  .el-menu-item.information.is-new-info > .icon {
    color: #d8243e;
  }

  .el-menu-item.information.is-new-info > .icon {
    display: inline-block;
    margin-left: 6px;
  }

  .toggle {
    color: #658bcd !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/side-navi.vue